import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import Header from './components/Header'
import Footer from './components/Footer'
import AdminScreen from './screens/AdminScreen'
import LoginScreen from './screens/LoginScreen'
import ContactScreen from './screens/Contactscreen'
import AboutScreen from './screens/AboutScreen'
import BlogPage from './pages/BlogPage'
import EnhancingPCRWithAI from './components/blogs/EnhancingPCRWithAI'
import ProtocolAssistant from './components/blogs/ProtocolAssistant'

import RegisterScreen from './screens/RegisterScreen';
import ProfileScreen from './screens/ProfileScreen';
import AccountScreen from './screens/AccountScreen';
import BuyCredits from './screens/BuyCredits';
import ResetPassword from './screens/ResetPassword';
import ChangePasswordScreen from './screens/ChangePasswordScreen';
import ConfirmRegistrationScreen from './screens/ConfirmRegistrationScreen';

import ReactGA from 'react-ga4';
import FaqScreen from './screens/FaqScreen'
import ProtocolScreen from './screens/ProtocolScreen'
import Subscription from './screens/Subscription'
import CreateScreen from './screens/CreateScreen'
import LandingPage from './screens/LandingPage'
import HowTo from './screens/HowTo'
import LabScreen from './screens/LabScreen'
import MergeScreen from './screens/MergeScreen'
import Template from './screens/Template'
import Feedback from './screens/Feedback';
import ReportConfigScreen from './screens/ReportConfigScreen';
import RealtimeScreen from './screens/RealtimeScreen';
import DocumentScreen from './screens/DocumentScreen';

// ReactGA.initialize('G-QVZ1KMF2BC');

function App() {

    useEffect(() => {
      ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }, []);

    return (
      <HelmetProvider>
        <Router>
          <Header/>
          <main className='py-3'>
            <Container>
              <Routes>
                <Route path='/login' Component={LoginScreen} />
                <Route path='/register' Component={RegisterScreen} />
                <Route path='/profile' Component={ProfileScreen} />
                <Route path='/account' Component={AccountScreen} />
                <Route path='/admin' Component={AdminScreen} />
                <Route path='/contact' Component={ContactScreen} />
                <Route path='/credits' Component={BuyCredits} />
                <Route path='/resetpwd' Component={ResetPassword} />
                <Route path='/reset/:id' Component={ChangePasswordScreen} />
                <Route path='/confirm/:id' Component={ConfirmRegistrationScreen} />
                <Route path="/faq" Component={FaqScreen} />
                <Route path='/template' Component={Template}/>
                <Route path='/feedback' Component={Feedback}/>
                <Route path='/protocol' Component={ProtocolScreen}/>
                <Route path='/subscription' Component={Subscription}/>
                <Route path='/report-config' Component={ReportConfigScreen}/>
                <Route path='/documents' Component={DocumentScreen}/>
                <Route path='/create' Component={CreateScreen}/>
                <Route path='/' Component={LandingPage} />
                <Route path="/howto" Component={HowTo} />
                <Route path='/lab' Component={LabScreen}/>
                <Route path='/merge' Component={MergeScreen}/>
                <Route path='/about' Component={AboutScreen} />
                <Route path='/blog' Component={BlogPage} />
                <Route path='/blog/enhancing-pcr-with-ai' Component={EnhancingPCRWithAI} />
                <Route path='/blog/protocol-assistant' Component={ProtocolAssistant} />
                <Route path='/realtime' Component={RealtimeScreen} />
              </Routes>
            </Container>
          </main>
          <Footer/>
        </Router>
      </HelmetProvider>
    );
}

export default App;
